import { useAppDisplayModeContext } from '@archipro-design/aria';
import type { NavItem } from '../../type';
import { useMatches } from 'react-router';
import CategoryNavigationDesktop from './CategoryNavigation.desktop';
import CategoryNavigationMobile from './CategoryNavigation.mobile';

export interface CategoryNavigationProp {
    navItems: NavItem[];
    activeRoute?: string;
}

const CategoryNavigation: React.FC<CategoryNavigationProp> = ({ navItems }) => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const matchingRoutes = useMatches();
    const activeRoute = matchingRoutes[
        matchingRoutes.length - 1
    ]?.pathname.replace(/\/$/, '');

    const args: CategoryNavigationProp = { activeRoute, navItems };

    if (isMobile) {
        return <CategoryNavigationMobile {...args} />;
    }

    return <CategoryNavigationDesktop {...args} />;
};

export default CategoryNavigation;
